import { MessageBatchV1, MessageV1, UploadResponseV1 } from '@csp/dmdp-api-usage-tracker-dto';
import { RestOptions } from '@csp/csp-common-model';
import { usagetrackerUrl } from '../../dmdp-config/dmdpConfig';

const baseUrl = (): string => `${usagetrackerUrl()}/segment-connections/v1`;

const batch = async ({ axios, ...config }: RestOptions, payload: MessageBatchV1): Promise<UploadResponseV1> => {
  const response = await axios.post(`${baseUrl()}/batch`, payload, config);
  return response.data;
};

const page = async ({ axios, ...config }: RestOptions, payload: MessageV1): Promise<UploadResponseV1> => {
  const response = await axios.post(`${baseUrl()}/p`, payload, config);
  return response.data;
};

const track = async ({ axios, ...config }: RestOptions, payload: MessageV1): Promise<UploadResponseV1> => {
  const response = await axios.post(`${baseUrl()}/t`, payload, config);
  return response.data;
};

const identify = async ({ axios, ...config }: RestOptions, payload: MessageV1): Promise<UploadResponseV1> => {
  const response = await axios.post(`${baseUrl()}/i`, payload, config);
  return response.data;
};

export const UsageTrackerRestServiceV1 = {
  batch,
  page,
  track,
  identify,
};
